import * as React from 'react';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import Translate from '../../common/functions/translate';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import { OfferStatus } from "../../common/enums";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FileModel } from "../../models/fileModel";
import { Checkbox } from 'primereact/components/checkbox/Checkbox';


const OfferList = (props) => {
  return (
    <DataTable
      value={props.offers}
      responsive
      paginator={true}
      lazy={true}
      rowsPerPageOptions={[10, 20, 50, 100]}
      rows={props.rows}
      totalRecords={props.totalRecords}
      onPage={(event) => props.onPageClick(event)}
      first={props.first}
      dataKey='id'
    //scrollable={false}
    >
      {props.isVisibleSelectColumn ?
        <Column
          style={{ width: 45 }}
          header={
            <Checkbox
              onChange={e => props.toggleAll(e.checked)}
              checked={props.allSelected}
            />
          }

          body={(rowData, column) => (
            rowData.offerStatusId !== OfferStatus.Finished
              ? <Checkbox
                onChange={(e) => props.selectDataRowClick(e, rowData)}
                checked={props.selectedOffers.some(offer => offer.id === rowData.id)}
              />
              : null
          )}
        />
        : null}
      <Column
        field={"offerDate"}
        header={Translate("Date")}
        body={(rowData, column) =>
          <div>
            {HelperFunctions.fomatDatesStringWithLang(new Date(rowData.offerDate))}
          </div>
        }
      />
      <Column
        field={"offerStatusId"}
        header={Translate("Status")}
        body={(rowData, column) =>
          <div style={HelperFunctions.getOfferStatusColor(rowData.offerStatusId)} >
            {HelperFunctions.getEnumLabel(rowData.offerStatusId, OfferStatus, true)}
          </div>
        }
      />
      <Column
        field="offerNumber"
        header={Translate("Number")}
        body={(rowData, column) =>
          <div style={{ cursor: "pointer" }} >
            <a
              href="/"
              style={{ textDecoration: "underline" }}
              onClick={(e) => props.editClick(e, rowData.id)}>
              {rowData.offerNumber}
            </a>
          </div>
        }
      />
      <Column field="regionName" header={Translate("Region")} />
      <Column field="traderName" header={Translate("Trader")} />
      <Column field="clientName" header={Translate("Client")} />
      <Column field="clientTown" header={Translate("City")} />
      <Column field="clientAddress" header={Translate("Address")} />
      {/* <Column field="boilerMake" header={Translate("BoilerMake")} /> */}
      <Column
        header={`${Translate("Price")} (${Translate('w/о VAT')})`}
        field="offerPrice"
        className='data-table-cell'
        body={(rowData, column) =>
          <>
            {rowData.offerPrice.toFixed(2)}
          </>
        }
      />

      <Column
        header={Translate("Files")}
        style={{ textAlign: "center", width: "15%" }}
        body={(rowData, column) =>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "center", alignItems: "center" }}>
            {rowData.offerFiles && rowData.offerFiles.length > 0
              ? rowData.offerFiles.map((o: FileModel, index) =>
                <div
                  key={o.fileId ? o.fileId + 'doc' : index + 'temp'}
                  style={{ marginRight: ".5em", cursor: "pointer" }}
                  onClick={(e) => props.downloadFileClick(e, o.fileId, o.fileName, o.fileSystemTypeId)}
                >
                  <FontAwesomeIcon
                    icon={HelperFunctions.getFileIconType(o.fileType)}
                    style={{ fontSize: 30, color: "#2196f3" }}
                    title={o.fileName}
                  ></FontAwesomeIcon>
                </div>
              )
              : null}
          </div>
        }
      />

      <Column
        header={Translate("Actions")}
        style={{ textAlign: "center", width: "10em" }}
        body={(rowData, column) =>
          <div style={{ textAlign: "left" }}>

            <Button
              type="button"
              icon="pi pi-pencil"
              className="p-button-warning"
              tooltip={Translate("Edit")}
              tooltipOptions={{ position: 'top' }}
              style={{ marginRight: ".5em" }}
              onClick={(e) => props.editClick(e, rowData.id)}
            />

            {props.isAdmin && (rowData.offerStatusId === OfferStatus.New) ?
              <Button
                type="button"
                icon="pi pi-trash"
                className="p-button-danger"
                tooltip={Translate("Delete")}
                tooltipOptions={{ position: 'top' }}
                style={{ marginRight: ".5em" }}
                onClick={(e) => props.deleteClick(rowData.id, e)}
              />
              : null}

            {rowData.priceChanged ?
              <Button
                type="button"
                icon="pi pi-info"
                className="p-button-info"
                tooltip={Translate("Recalculate")}
                tooltipOptions={{ position: 'top' }}
                onClick={(e) => props.recalculateClick(rowData.id, e)}
              />
              : null}

          </div>
        }
      />
    </DataTable>
  )
}

export default OfferList;
